import * as React from 'react'

import {deleteTeacherLicenseAllocation} from '@frontrow/console/src/helpers/api-teachers'
import {type TeacherLicenseAllocationT} from '@frontrow/console/src/models/teacher-license-allocation'
import {firstResponseApiError} from '@frontrow/console/src/entities/models/api-error'
import LicenseRow from '@frontrow/console/src/components/pages/teachers-page/teacher-licenses/license-row/license-row'

type LicenseRowContainerProps = {
  license: TeacherLicenseAllocationT
  mutateTeacherLicenses: () => void
}

export default function LicenseRowContainer({
  license,
  mutateTeacherLicenses
}: LicenseRowContainerProps): React.ReactElement {
  const removeLicense = React.useCallback(async (): Promise<void> => {
    try {
      await deleteTeacherLicenseAllocation(license.id)

      // Revalidate to sync with server
      mutateTeacherLicenses()
    } catch (error: unknown) {
      const apiError = firstResponseApiError(error)
      throw new Error(apiError.message)
    }
  }, [license.id, mutateTeacherLicenses])

  return <LicenseRow license={license} removeLicense={removeLicense} />
}
